import { useTier } from "@/context/TierContext";
import { Button } from "@/components/ui/button";
import { InfoTip } from "@/components/InfoTip";
import { Lock, Sparkles } from "lucide-react";

export function PremiumLock({ title, description, feature = "premium", icon: Icon = Lock, testId = "premium-lock", tip }) {
  const { openUpgrade } = useTier();
  return (
    <div data-testid={testId} className="mt-4 rounded-2xl border border-white/10 bg-white/5 p-5 text-white">
      <div className="flex items-center gap-3">
        <span className="grid place-items-center h-10 w-10 rounded-xl bg-white/10 text-white/60 shrink-0"><Icon size={20} /></span>
        <div>
          <h3 className="font-heading font-semibold flex items-center gap-2">{title} <Lock size={13} className="text-white/50" />{tip && <InfoTip topic={tip} dark side="top" />}</h3>
          <p className="text-sm text-white/55">{description}</p>
        </div>
      </div>
      <Button data-testid={`${testId}-upgrade-btn`} onClick={() => openUpgrade(feature)}
        className="mt-4 h-11 rounded-xl bg-brand hover:bg-brand-hover text-white font-semibold">
        <Sparkles size={16} className="mr-2" /> Upgrade to TenantSeal Plus — $6/mo
      </Button>
    </div>
  );
}
